import {
  EnumCutsheetAnimalSpecies,
  EnumCutsheetInspectionLevels,
  ProducerJobByIdQuery,
  SearchCustomersQuery,
} from 'lib/graphql';

export type Job = NonNullable<ProducerJobByIdQuery['processorSchedulingById']>;
export type AnimalHead = NonNullable<Job['animalHeads']>[number];

export type CutsheetInfo = NonNullable<
  NonNullable<NonNullable<AnimalHead>['cutsheetInformation']>[number]
>;

export type SplitSlotDef = {
  label: string;
  part: 'whole' | 'half' | 'quarter';
};

export type CustomerResult = NonNullable<
  SearchCustomersQuery['searchCustomers']
>[number];

// ---------------------------------------------------------------------------
// Narrower interfaces for components that accept data from either
// ProducerJobByIdQuery OR ProcessorSchedulingPaginationQuery.
// Both query types satisfy these interfaces, eliminating `as any` casts.
// ---------------------------------------------------------------------------

export interface DrawerJob {
  _id: string;
  vendor?: { _id?: string | null; shop_name?: string | null } | null;
  animalSpecies?: string | null;
  requestedBy?: { _id?: string | null } | null;
}

export interface DrawerHead {
  inspectionLevel?: string | null;
}

export interface DrawerCutsheetInfo {
  _id?: string | null;
  contactUser?: { _id?: string | null } | null;
  locked?: boolean | null;
  cutsheet?: { _id?: string | null; name?: string | null } | null;
}

// ---------------------------------------------------------------------------
// Enum cast helpers — centralise the `as unknown as` casts required because
// GQL codegen produces `Maybe<string>` for enum fields on pagination queries.
// ---------------------------------------------------------------------------

export function asSpecies(v: unknown): EnumCutsheetAnimalSpecies | undefined {
  return (v ?? undefined) as EnumCutsheetAnimalSpecies | undefined;
}

export function asInspectionLevel(
  v: unknown,
): EnumCutsheetInspectionLevels | undefined {
  return (v ?? undefined) as EnumCutsheetInspectionLevels | undefined;
}
